import Svg, { Path } from 'react-native-svg';
import { IconProps } from './types';
import { colors } from '../constants';

export const IconBell = ({
  width = 24,
  height = 24,
  color = colors.primary,
}: IconProps) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 20 21" fill="none">
      <Path
        d="M2 17.05V15.05H4V8.05C4 6.66667 4.41667 5.4375 5.25 4.3625C6.08333 3.2875 7.16667 2.58333 8.5 2.25V1.55C8.5 1.13333 8.64583 0.779167 8.9375 0.4875C9.22917 0.195833 9.58333 0.05 10 0.05C10.4167 0.05 10.7708 0.195833 11.0625 0.4875C11.3542 0.779167 11.5 1.13333 11.5 1.55V2.25C12.8333 2.58333 13.9167 3.2875 14.75 4.3625C15.5833 5.4375 16 6.66667 16 8.05V15.05H18V17.05H2ZM10 20.05C9.45 20.05 8.97917 19.8542 8.5875 19.4625C8.19583 19.0708 8 18.6 8 18.05H12C12 18.6 11.8042 19.0708 11.4125 19.4625C11.0208 19.8542 10.55 20.05 10 20.05ZM0 8.05C0 6.38333 0.370833 4.85417 1.1125 3.4625C1.85417 2.07083 2.85 0.916667 4.1 0L5.275 1.6C4.275 2.33333 3.47917 3.25833 2.8875 4.375C2.29583 5.49167 2 6.71667 2 8.05H0ZM18 8.05C18 6.71667 17.7042 5.49167 17.1125 4.375C16.5208 3.25833 15.725 2.33333 14.725 1.6L15.9 0C17.15 0.916667 18.1458 2.07083 18.8875 3.4625C19.6292 4.85417 20 6.38333 20 8.05H18Z"
        fill={color}
      />
    </Svg>
  );
};
